/**
 * @generated SignedSource<<3f95f65c716136449ac13837e6bda568>>
 * @relayHash 4d345b23d5d826c28fd9a0b53c39f429
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00f6af7f437b3db68ad04ba7e279b12c1ab871fd98295d3f14d088351f44163e

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdatesSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdatesSubscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdatesSubscription = {
  response: IssueRealtimeUpdatesSubscription$data;
  variables: IssueRealtimeUpdatesSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdatesSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdatesSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "00f6af7f437b3db68ad04ba7e279b12c1ab871fd98295d3f14d088351f44163e",
    "metadata": {},
    "name": "IssueRealtimeUpdatesSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "580dfbce208323793cd1d983e2d4565b";

export default node;
